export function getProblemMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== "object") {
    return fallback;
  }

  const detail =
    "detail" in error && typeof error.detail === "string"
      ? error.detail.trim()
      : "";
  if (detail) {
    return detail;
  }

  const title =
    "title" in error && typeof error.title === "string"
      ? error.title.trim()
      : "";
  if (title) {
    return title;
  }

  return fallback;
}
